import { useQuery } from '@tanstack/react-query';
import { httpService } from '../../../utils/apiService';

export const useAdminNotifications = ({ params, options = {} }) =>
  useQuery({
    queryKey: ['ADMIN_NOTIFICATIONS', params],
    queryFn: async () => {
      const response = await httpService.post('notifications/admin/list', params);
      return response.data.data;
    },
    refetchOnWindowFocus: false,
    ...options,
  });
